"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareAccessUnavailable = ShareAccessUnavailable;
var _react = _interopRequireDefault(require("react"));
var _card = require("@design/ui/card");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SHARE_PANEL_WIDTH = 400;
function ShareAccessUnavailable() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.Card, {
    style: {
      width: SHARE_PANEL_WIDTH
    },
    "data-sentry-element": "Card",
    "data-sentry-component": "ShareAccessUnavailable",
    "data-sentry-source-file": "ShareAccessUnavailable.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
      "data-sentry-element": "CardContent",
      "data-sentry-source-file": "ShareAccessUnavailable.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "text-destructive",
        children: "Sharing permissions couldn't be loaded for this item. Refresh and try again."
      })
    })
  });
}